<h3 class="mat-h2  __heading" [innerHTML]="heading"></h3>

<p class="mat-body  __desc" [innerHTML]="desc"></p>

<ng-content></ng-content>
